@import "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&family=Roboto+Condensed:wght@400;500;600;700&display=swap";

/* src/app/common/components/catalog/catalog.component.scss */
:root {
  --poppins-font: "Poppins", sans-serif;
  --roboto-font: "Roboto Condensed", sans-serif;
}
:host {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.spotlight-container {
  position: relative;
}
.spotlight-container .spotlight {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.toolbar-container ion-toolbar {
  --background: transparent;
  --min-height: auto;
}
.toolbar-container ion-toolbar .actions {
  margin-right: -0.5rem;
}
.toolbar-container ion-toolbar .actions ion-button {
  margin: 0 0.5rem;
}
.content-container {
  height: 100%;
}
.content-container .menus {
  border-right: 1px solid rgba(0, 0, 0, 0.07);
  width: 250px;
  min-width: 250px;
  overflow-y: scroll;
  scrollbar-color: #28a745 #f0f0f0;
  scrollbar-width: thin;
}
.content-container .menus ion-item {
  transition: font-weight 0.2s cubic-bezier(0.5, 1, 0.89, 1);
}
.content-container .items {
  overflow: auto;
  --ion-grid-padding: 0.5rem;
  --ion-grid-column-padding: 1rem;
}
.card-wrapper {
  padding: 1rem;
}
ion-card {
  padding: 1rem;
  margin: 0;
  border-radius: var(--card-border-radius, 0);
  box-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.13);
  box-sizing: border-box;
  transition: border-color 0.1s ease-in-out 0.25s;
}
ion-card:focus-within,
ion-card:hover {
  border-color: var(--ion-color-secondary);
}
ion-card:focus-within div.cart-mgmt,
ion-card:hover div.cart-mgmt {
  border-color: var(--ion-color-secondary);
}
ion-card .thumbnail {
  height: 100px;
  max-height: 100px;
  overflow: hidden;
  background-image: url(https://ionicframework.com/docs/demos/api/thumbnail/thumbnail.svg);
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-background-size: cover;
  background-size: cover;
  position: relative;
}
ion-card .thumbnail app-food-type-indicator {
  position: absolute;
  right: 0.25rem;
  top: 0.25rem;
}
ion-card ion-card-header {
  padding: 0;
}
ion-card ion-card-header .title-container {
  margin-bottom: -18px;
}
ion-card ion-card-header ion-card-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
ion-card .tags > * {
  display: inline-block;
  vertical-align: middle;
  padding: 0 2px;
}
ion-card ion-card-content {
  padding: 0;
  padding-top: 0.25rem;
}
ion-card ion-card-content > * {
  padding: 0.25rem 0;
}
ion-card ion-card-content .dashboard {
  border: 1px solid red;
}
ion-card ion-card-content .description {
  text-align: justify;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 220px;
}
ion-card ion-card-content .description:hover {
  height: auto;
  width: 100%;
  white-space: normal;
  transition: all 0.3s ease;
}
ion-card .bold-text {
  font-weight: bold;
}
ion-card .quantity-info {
  display: flex;
  justify-content: space-between;
}
ion-card div.cart-mgmt {
  margin: -1rem;
  margin-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.13);
  transition: border-color 0.1s ease-in-out 0.25s;
}
ion-card div.cart-mgmt app-quantity-selector {
  display: block;
}
h3 {
  position: relative;
}
h3 ion-icon {
  position: relative;
  z-index: 1;
}
h3 .link-ref {
  position: absolute;
  top: -2.5rem;
  right: 0;
  bottom: 0;
  left: 0;
}
ion-fab {
  --ion-safe-area-right: 20px;
}
* {
  scrollbar-color: #356859 #f0f0f0;
  scrollbar-width: thin;
}
* ::-webkit-scrollbar {
  width: 10px;
}
* ::-webkit-scrollbar-track {
  background: #f0f0f0;
}
* ::-webkit-scrollbar-thumb {
  background: #356859;
}
* ::-webkit-scrollbar-thumb:hover {
  background: #4e9680;
}
.menus::-webkit-scrollbar {
  width: 5px;
}
.menus::-webkit-scrollbar-track {
  background: #f0f0f0;
}
.menus::-webkit-scrollbar-thumb {
  background: #28a745;
  border-radius: 6px;
}
.menus::-webkit-scrollbar-thumb:hover {
  background: #218d3a;
}
.custom-fab-button {
  width: 80px !important;
  height: 42px !important;
  --border-radius: 10px !important;
}
.custom-fab-button .custom-fab-icon {
  font-size: 18px !important;
  color: #f6f6fc !important;
}
.custom-fab-button .label-text {
  font: normal normal 500 14px/18px Poppins;
  color: #ffffff;
}
.text-color-secondary {
  color: #098cff;
  font-family: var(--poppins-font);
  font-weight: 600 !important;
}
.text-color-secondary:hover {
  color: #0975d3 !important;
  text-decoration: underline !important;
}
.info-title {
  font-size: 16px;
  font-weight: 600 !important;
  font-family: var(--poppins-font) !important;
  letter-spacing: 1.2px;
  color: #242323;
  white-space: normal !important;
}
.custom-signin-btn,
.custom-signup-btn {
  --border-width: 0px !important;
  font-size: 16px;
  color: var(--ion-color-success-shade);
}
/*# sourceMappingURL=catalog.component.css.map */
